import { useMemo } from 'react';
import { getPieChartWithOthers } from '../../../prompt/preview/components/stats/helpers/StatsHelper';
import { AllBrandsStatsResponse } from '../../../../shared/models/projects/stats/AllBrandsStatsResponse';
import { KeywordResponse } from '../../../../shared/models/monitor/KeywordResponse';
import { TagsResponse } from '../../../../shared/models/tags/TagsResponse';

export const useShareOfVoiceData = (
  allBrandsStatsResponse: AllBrandsStatsResponse[],
  keywordsMap: Map<string, string>,
  firmName: string,
  commonKeywords: KeywordResponse[],
  tags: TagsResponse[]
) =>
  useMemo(() => {
    if (!allBrandsStatsResponse || keywordsMap.size === 0 || !commonKeywords || !tags) {
      return [];
    }

    const pieChartData = allBrandsStatsResponse.map((stats) => ({
      name: stats.keyword,
      value: stats.shareOfVoice,
    }));

    return getPieChartWithOthers(pieChartData, firmName, keywordsMap, commonKeywords, tags);
  }, [allBrandsStatsResponse, keywordsMap, firmName, commonKeywords, tags]);
